import KeenSlider from 'keen-slider'

window.addEventListener('DOMContentLoaded', () => {
	// Measure childPagesText elements to get height for expand on hover CSS
	const childPagesText = document.querySelectorAll(
		'.thriveLocallyParent .childPages .child p'
	)

	// Need to give a pause because I think layout shift is causing this measurement to be incorrect in the beginning
	setTimeout(() => {
		childPagesText.forEach(childPageText => {
			childPageText.setAttribute(
				'style',
				`--height: ${childPageText.scrollHeight}px`
			)
		})

		window.addEventListener('resize', () => {
			childPagesText.forEach(childPageText => {
				childPageText.setAttribute('style', `--height: auto`)
				childPageText.setAttribute(
					'style',
					`--height: ${childPageText.scrollHeight}px`
				)
			})
		})
	}, 100)

	// Slider on child pages
	const sliderWrappers = document.querySelectorAll(
		'.thriveLocallyChild .cardWithSlider .slider-wrapper'
	)
	sliderWrappers.forEach(sliderWrapper => {
		const dots = sliderWrapper.querySelectorAll('.dots .dot')
		const prevArrow = sliderWrapper.querySelector('button.slider-control.prev')
		const nextArrow = sliderWrapper.querySelector('button.slider-control.next')
		const sliderEl = sliderWrapper.querySelector('.keen-slider')
		const numSlides = sliderEl.querySelectorAll('.keen-slider__slide').length

		var slider = new KeenSlider(
			sliderEl,
			{
				loop: true,
				slides: {
					perView: 1,
				},
				breakpoints: {
					'(min-width: 640px)': {
						loop: false,
						slides: {
							perView: numSlides >= 2 ? 2 : 1,
						},
					},
					'(min-width: 1900px)': {
						loop: false,
						slides: {
							perView: numSlides >= 3 ? 3 : numSlides >= 2 ? 2 : 1,
						},
					},
				},
			},
			[
				slider => {
					function updateClasses() {
						var slide = slider.track.details.rel
						slide === 0
							? prevArrow.classList.add('arrow--disabled')
							: prevArrow.classList.remove('arrow--disabled')
						slide === slider.track.details.slides.length - 1
							? nextArrow.classList.add('arrow--disabled')
							: nextArrow.classList.remove('arrow--disabled')
						dots.forEach(dot => {
							let idx = parseInt(dot.dataset.index)
							if (
								slider.options.slides.perView >= 3 &&
								(idx === slide + 1 || idx === slide + 2)
							) {
								dot.classList.add('dot--active')
							} else if (
								slider.options.slides.perView >= 2 &&
								idx === slide + 1
							) {
								dot.classList.add('dot--active')
							} else if (idx === slide) {
								dot.classList.add('dot--active')
							} else {
								dot.classList.remove('dot--active')
							}
						})
					}
					dots.forEach(dot => {
						dot.addEventListener('click', () => {
							let idx = parseInt(dot.dataset.index)
							idx =
								idx > slider.track.details.maxIdx
									? slider.track.details.maxIdx
									: idx
							slider.moveToIdx(idx)
						})
					})
					prevArrow.addEventListener('click', () => {
						slider.prev()
					})
					nextArrow.addEventListener('click', () => {
						slider.next()
					})
					slider.on('created', () => {
						updateClasses()
					})
					slider.on('slideChanged', () => {
						updateClasses()
					})
					slider.on('optionsChanged', () => {
						updateClasses()
					})
				},
			]
		)

		setTimeout(() => {
			slider.update()
		}, 1000)
	})
})
